import { useAddPositionsContext } from '@/components/investments/add-positions/AddPositionsProvider';
import type { WealthicaPosition } from '@/providers/wealthica2/types';
import type { GenericPosition } from '@/components/investments/dialog/types';

export function useAddPositions() {
  const { open, close } = useAddPositionsContext();
  return {
    openAddPositions: (opts: { positions: (WealthicaPosition | GenericPosition)[]; navigateOnZeroAdded?: boolean; onSuccess?: () => void; onClose?: () => void }) => open(opts),
    closeAddPositions: close,
  } as const;
}
